'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoCheckmarkRound = function IoCheckmarkRound(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.8 5.6c1.3 1 1.7 3.1 0.7 4.5l-16.2 23.6c-1 1.4-2.9 1.7-4.2 0.7s-10.7-11.5-10.7-11.5c-1.2-1.3-1.2-3.3 0-4.5s3.2-1.2 4.3 0.1l7.8 8.4 14-20.6c1-1.4 2.9-1.7 4.3-0.7z' })
        )
    );
};

exports.default = IoCheckmarkRound;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/checkmark-round.js
// module id = 2219
// module chunks = 0